import "./App.css";
import React, { useEffect, useState, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DropdownPicker from "./components/dropdown-picker";
import { SvgIcon } from "@mui/material";
import * as Constants from "./constants";
import DaysHalf from "./methods/days-half";
import DaysHalfDisabled from "./methods/days-half-disabled";
import Days from "./methods/days";
import HoursSpanned from "./methods/hours-spanned";
import Hours from "./methods/hours";
import DateHoursInput from "./methods/date-hours-input";
import CheckInOut from "./methods/check-in-out";
import HoursAndDaysWhole from "./methods/hours-and-days-whole";
import DaysHalfAndHours from "./methods/days-half-and-hours";
import Mileage from "./methods/mileage";
import { useDispatch, useSelector } from "react-redux";
import { getRule } from "./store/rule/actions";
import AddNote from "./components/add-note";
import LeaveType from "./components/leave-type";
import RecurringItem from "./components/recurring-item";
import DialogBox from "./components/dialog-box";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CheckIcon from "@mui/icons-material/Check";
import BlockIcon from "@mui/icons-material/Block";
import moment from "moment";
import { isEmpty } from "lodash";
import { getUserInfo, getGUID, getSelectedCode } from "./store/user/actions";
import { getSetting } from "./store/setting/actions";
import DaysHalfAndHoursDisabled from "./methods/days-half-and-hours-disabled";
import { getRegistration } from "./store/registration/actions";

export default function Registration({ GUID }) {
  const dispatch = useDispatch();
  const [registrationTypes, setRegistrationTypes] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedCode, setSelectedCode] = useState("");
  const [subTypeSelected, setSubTypeSelected] = useState("");
  const [subtypeMethod, setSubtypeMethod] = useState();
  const [subtypeAddNote, setSubtypeAddNote] = useState();
  const [subtypeRecurence, setSubtypeRecurence] = useState();
  const [jobcode, setJobcode] = useState("");
  const [searchText, setSearchText] = useState("");
  const [dialogBoxColor, setDialogBoxColor] = useState();
  const [dialogMessage, setDialogMessage] = useState();
  const [dialogIcon, setDialogIcon] = useState();
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [timeFrom, setTimeFrom] = useState(
    moment(new Date().setHours(0, 0, 0, 0))
  );
  const [timeTo, setTimeTo] = useState(moment(new Date().setHours(0, 0, 0, 0)));
  const [isRecurrentChecked, setIsRecurrentChecked] = useState(false);
  const [isVacationChecked, setIsVacationChecked] = useState(false);
  const [isToggle, setIsToggle] = useState(false);
  const [halfDays, setHalfDays] = useState("");
  const [repeatWeek, setRepeatWeek] = useState(0);
  const [daysSelected, setDaysSelected] = useState({
    Mo: false,
    Tu: false,
    We: false,
    Th: false,
    Fr: false,
    Sa: false,
    Su: false,
  });
  const [isShowHours, setIsShowHours] = useState(false);
  const [addNote, setAddNote] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [jobcodes, setJobcodes] = useState();
  const setting = useSelector((state) => state.SettingReducer.settings);
  const rules = useSelector((state) => state.RulesReducer.rules);
  const registration = useSelector(
    (state) => state.RegistrationSaga.registration
  );
  const userInfo = useSelector((state) => state.UserInfoSaga.users);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = {
    type: selectedCode || "",
    employeeGuid: GUID,
    lang: userInfo?.webLang || "en",
  };

  const rulesParams = {
    employeeGuid: GUID,
    to: `${dateTo} ${moment(timeTo).format("HH:mm")}`,
    from: `${dateFrom} ${moment(timeFrom).format("HH:mm")}`,
    reasonId: selectedCode,
    language: "en",
    employeeId: 0,
    pageId: 0,
    eventId: "",
    ownerId: 0,
    timePeriod: "",
    halfDay: halfDays,
    isHours: isShowHours,
    isRecurrent: isRecurrentChecked,
    recurrentDays: [],
    repeatWeek: 0,
    workflowState: "",
    isMobile: true,
    isEdit: true,
    subtypeId: "",
    note: addNote,
    breaksId: [],
    companyGuid: "",
  };

  useEffect(() => {
    dispatch(getUserInfo(GUID));
    dispatch(getGUID(GUID));
    setDateFrom(moment(new Date()).format("YYYY-MM-DD"));
    setDateTo(moment(new Date()).format("YYYY-MM-DD"));

    if (typeof window?.ReactNativeWebView !== "undefined") {
      setIsMobile(true);
    }
  }, []);

  useEffect(() => {
    initialSubTypes();
  }, [setting]);

  useEffect(() => {
    if (
      !isEmpty(userInfo) &&
      !isEmpty(params?.type) &&
      !isEmpty(params?.lang)
    ) {
      dispatch(getSetting(params));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCode, userInfo]);

  useEffect(() => {
    if (!isEmpty(setting)) {
      dispatch(getRule(rulesParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setting, dateFrom, dateTo]);

  useEffect(() => {
    if (isVacationChecked) {
      onSetHalfDay();
    } else {
      setHalfDays("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVacationChecked, isToggle]);

  useEffect(() => {
    try {
      if (registration && registration.status === 201) {
        window?.ReactNativeWebView?.postMessage("save");
      }
    } catch (error) {
      console.log(error);
    }
  }, [registration]);

  useEffect(() => {
    if (registrationTypes.length > 0) {
      setSelectedType(registrationTypes[0]);
    }
  }, [registrationTypes]);

  useEffect(() => {
    try {
      setDialogBoxStatus(rules?.status);
    } catch (error) {
      console.log(error);
    }
  }, [rules]);

  useEffect(() => {
    if (isShowHours) {
      setTimeFrom(moment().toISOString());
      setTimeTo(moment().toISOString());
    } else {
      setTimeFrom(moment(new Date().setHours(0, 0, 0, 0)));
      setTimeTo(moment(new Date().setHours(0, 0, 0, 0)));
    }
  }, [isShowHours]);

  // set leave types
  useEffect(() => {
    let types = [];
    let userAccess = [];
    let company = [];

    for (const key in userInfo.policy) {
      if (Object.hasOwnProperty.call(userInfo.policy, key)) {
        const element = userInfo.policy[key];
        if (element === true || key === "leaveTypes") {
          let text;
          switch (key) {
            case "registerVacation":
              text = "Vacation";
              break;
            case "registerOtherVacation":
              text = userInfo.policy.othervacationName || "Other vacation";
              break;
            case "registerSick":
              text = userInfo.policy.sickName || "Sick";
              break;
            case "registerChildSick":
              text = userInfo.policy.childSickName || "Child sick";
              break;
            case "leaveTypes":
              if (userInfo.policy.leaveTypes.length > 0) {
                if (!isEmpty(userInfo.policy.leaveName)) {
                  text = userInfo.policy.leaveName;
                } else {
                  text = "Other leave";
                }
              }
              break;
            case "registercheckinout":
              text = "Work hours";
              break;
            default:
              break;
          }
          if (text) {
            types.push(text);
          }
        }
      }
    }

    for (const key in userInfo.userAccess) {
      if (Object.hasOwnProperty.call(userInfo.userAccess, key)) {
        const element = userInfo.userAccess[key];
        if (
          key !== "CompanyCalendar" &&
          key !== "OutOfOffice" &&
          element === true
        ) {
          userAccess.push(key);
        }
      }
    }

    for (const key in userInfo.company) {
      if (Object.hasOwnProperty.call(userInfo.company, key)) {
        const element = userInfo.company[key];
        if (
          key === "timebankName" ||
          key === "daybankName" ||
          key === "owntypesName"
        ) {
          company.push(element);
        }
      }
    }

    userAccess.filter((i) => {
      switch (i) {
        case "Time":
          types.push("Time registration");
          break;
        case "Daybank":
          types.push(company[1]);
          break;
        case "OwnTypes":
          types.push(company[2]);
          break;
        case "Timebank":
          types.push(company[0]);
          break;
        case "Mileage":
          types.push(i);
          break;
        default:
          break;
      }
    });

    setRegistrationTypes(types);
    setSelected(types[0]);
  }, [userInfo]);

  // selected vacation type
  const onSelectedTypeChange = useCallback((event) => {
    const {
      target: { value },
    } = event;
    setSelectedType(typeof value === "string" ? value : "");
    initialJobcodes();
    setSelected(value);
  }, []);

  const setSelected = useCallback(
    (type) => {
      let code;
      switch (type) {
        case Constants.SettingType.HH:
          code = Constants.HH;
          break;
        case Constants.SettingType.HF:
        case userInfo?.policy?.othervacationName:
          code = Constants.HF;
          break;
        case Constants.SettingType.IS:
        case userInfo?.policy?.sickName:
          code = Constants.IS;
          break;
        case Constants.SettingType.IC:
        case userInfo?.policy?.childSickName:
          code = Constants.IC;
          break;
        case Constants.SettingType.P:
        case userInfo?.company?.owntypesName:
          code = Constants.P;
          break;
        case Constants.SettingType.L:
        case userInfo?.policy?.leaveName:
          code = Constants.L;
          break;
        case Constants.SettingType.TT:
          code = Constants.TT;
          break;
        case Constants.SettingType.V:
        case userInfo?.company?.timebankName:
          code = Constants.V;
          break;
        case Constants.SettingType.D:
        case userInfo?.company?.daybankName:
          code = Constants.D;
          break;
        case Constants.SettingType.MI:
          code = Constants.MI;
          break;
        case Constants.SettingType.FT:
          code = Constants.FT;
          break;

        default:
          break;
      }
      dispatch(getSelectedCode(code));
      setSelectedCode(code);
    },
    [userInfo]
  );

  const initialSubTypes = () => {
    if (setting?.subtype && setting?.subtype?.length > 0) {
      if (userInfo?.policy?.leaveTypes?.length > 0) {
        setSubTypeSelected(userInfo?.policy?.leaveTypes[0]);
      } else {
        setSubTypeSelected(setting?.subtype[0]?.name);
      }
      setSubtypeMethod(setting?.subtype[0]?.method);
      setSubtypeAddNote(setting?.subtype[0]?.note);
      setSubtypeRecurence(setting?.subtype[0]?.reccurence);
      initialJobcodes(setting?.subtype[0]?.name);
      initialTime(setting?.subtype[0]?.name);
    }

    if (setting?.jobcodes && setting?.jobcodes?.length > 0) {
      setJobcode(setting?.jobcodes[0]?.name);
    }

    setDialogBoxStatus(rules?.status || -1);
  };

  const initialJobcodes = (value) => {
    const subtype = setting?.subtype?.find((i) => i.name === value);
    if (!isEmpty(subtype?.jobcodes)) {
      // eslint-disable-next-line array-callback-return
      setting?.subtype?.map((i) => {
        if (!isEmpty(i.jobcodes)) {
          setJobcodes(i.jobcodes);
          setJobcode(i?.jobcodes[0]?.name);
        }
      });
    } else {
      setJobcodes();
      setJobcode();
    }
  };

  const initialTime = (value) => {
    const subtype = setting?.subtype?.find((i) => i.name === value);
    if (subtype.unit === "hours") {
      setIsShowHours(true);
      setTimeFrom(moment().toISOString());
      setTimeTo(moment().toISOString());
    }
  };

  // selected subtype
  const onSubTypeSelected = (event) => {
    const {
      target: { value },
    } = event;
    setSubTypeSelected(typeof value === "string" ? value : "");
    initialJobcodes(value);
    findSubtypeMethod(value);
  };

  const findSubtypeMethod = (value) => {
    const subtype = setting.subtype.find((item) => item.name === value);
    if (subtype !== "" || subtype !== null) {
      setSubtypeMethod(subtype.method);
      setSubtypeAddNote(subtype.note);
      setSubtypeRecurence(subtype.reccurence);
    }
  };

  // selected date
  const onSelectedDateFrom = (value, str) => {
    const date = moment(value.toString()).format("YYYY-MM-DD HH:mm");
    if (value.isAfter(dateTo)) {
      setDateFrom(date);
      setDateTo(date);
    } else {
      setDateFrom(date);
    }
  };

  const onSelectedDateTo = (value, str) => {
    const date = moment(value.toString()).format("YYYY-MM-DD HH:mm");
    if (value.isBefore(dateFrom)) {
      setDateFrom(date);
      setDateTo(date);
    } else {
      setDateTo(date);
    }
  };

  const onHandleToggle = useCallback(() => {
    setIsToggle(!isToggle);
  }, [isToggle]);

  const onSetHalfDay = () => {
    if (!isToggle) {
      setHalfDays("am");
    } else {
      setHalfDays("pm");
    }
  };

  // selected job code
  const onJobcodeChange = (event) => {
    const {
      target: { value },
    } = event;
    setDialogBoxStatus(-1);
    setJobcode(value);
  };

  const onSearch = (event) => {
    setSearchText(event.target.value);
  };

  // checked half day and recurrent
  const onRecurrentChecked = () => {
    setIsRecurrentChecked((prev) => !prev);
  };

  const onVacationChecked = () => {
    setIsVacationChecked((prev) => !prev);
    setIsShowHours(false);
  };

  // dialog box message
  const setDialogBoxStatus = (status) => {
    switch (status) {
      case 0:
        setDialogBoxColor(Constants.StatusColor.error);
        setDialogIcon(BlockIcon);
        break;
      case 1:
        setDialogBoxColor(Constants.StatusColor.warning);
        setDialogIcon(PriorityHighIcon);
        break;
      case 2:
        setDialogBoxColor(Constants.StatusColor.info);
        setDialogIcon(CheckIcon);
        break;
      default:
        setDialogBoxColor("");
        setDialogIcon("");
        setDialogMessage("");
        break;
    }

    if (!isEmpty(rules?.rules) && status !== -1) {
      renderDialogBoxMessage();
    }
  };

  const renderDialogBoxMessage = () => {
    const value =
      rules?.rules?.allowOverlapMessage ||
      rules?.rules?.noCountOverlappingDaysOffMessage ||
      rules?.rules?.blockOverlappingWorkingWeeksMessage ||
      rules?.rules?.max2YearFutureMessage ||
      rules?.rules?.maxOneActiveCheckInMessage ||
      rules?.rules?.max24hperDAYMessage ||
      rules?.rules?.blockTimeOverTimeMessage ||
      rules?.rules?.blockOverlapENDBalancePeriodMessage ||
      rules?.rules?.blockFlextimeTimeOFFMessage ||
      rules?.rules?.blockBackInTimeMessage;

    const policiesMessage =
      rules?.policies?.maxYearMessage ||
      rules?.policies?.maxPerRegistrationMessage ||
      rules?.policies?.maxMonthMessage ||
      rules?.policies?.blockstandardHoursMissingMessage;

    switch (selectedCode) {
      case Constants.HH: {
        const messageDialog = `Vacation days available: ${
          rules?.daysAvailable || 0
        }\nVacation days selected: ${
          rules?.daysTaken || 0
        }\nVacation days left: ${rules?.daysLeft || 0}`;

        setDialogMessage(messageDialog);

        break;
      }
      default: {
        const messageDialog = `${
          !isEmpty(value)
            ? value
            : !isEmpty(policiesMessage)
            ? policiesMessage
            : ""
        }`;

        setDialogMessage(messageDialog);

        break;
      }
    }
  };

  const handleSetTimeFrom = (value) => {
    if (value) {
      const fromTime = moment(new Date(value));
      const toTime = moment(timeTo);
      setIsShowHours(true);
      setTimeFrom(fromTime.toISOString());

      if (fromTime?.diff(toTime) > 0) {
        setTimeTo(fromTime.toISOString());
      }
    }
  };

  const handleSetTimeTo = (value) => {
    if (value) {
      const fromTime = moment(timeFrom);
      const toTime = moment(new Date(value));
      setIsShowHours(true);
      setTimeTo(toTime.toISOString());

      if (fromTime?.diff(toTime) > 0) {
        setTimeFrom(toTime.toISOString());
      }
    }
  };

  const canSelectPastDate = () => {
    return (
      ![Constants.IS, Constants.IC].includes(selectedCode) &&
      !(!isEmpty(userInfo) && userInfo?.userRole?.includes("employee"))
    );
  };

  const shouldRenderDialogMessage = () => {
    let shouldRenderDialog = true;

    if (
      [Constants.IS, Constants.IC].includes(selectedCode) &&
      !isEmpty(rules) &&
      rules?.status === 2
    ) {
      shouldRenderDialog = false;
    } else if (isEmpty(rules)) {
      shouldRenderDialog = false;
    } else if (dialogMessage?.trim()?.length < 1) {
      shouldRenderDialog = false;
    }

    return shouldRenderDialog;
  };

  const shouldRenderSaveBtn = () => {
    let shouldRenderBtn = true;
    if (!isEmpty(rules) && rules?.status === 0) {
      shouldRenderBtn = false;
    }
    return shouldRenderBtn;
  };

  const shouldDateToSameAsDateFrom = (method) => {
    return [Constants.MethodType?.hours].includes(method);
  };

  const isMethodUse24HourFormat = (method) => {
    return [Constants.MethodType?.hours].includes(method);
  };

  const onShowHours = () => {
    setIsShowHours((prev) => !prev);
    setIsVacationChecked(false);
  };

  // render method
  const renderItem = (type) => {
    switch (type) {
      case Constants.MethodType.daysHalf:
        return (
          <DaysHalf
            onSelectedDateFrom={(value, str) => onSelectedDateFrom(value, str)}
            dateFrom={dateFrom}
            onSelectedDateTo={(value) => onSelectedDateTo(value)}
            dateTo={dateTo}
            checked={isVacationChecked}
            onChecked={() => onVacationChecked()}
            defaultAM={isToggle}
            onHandleToggle={() => onHandleToggle()}
            canSelectPast={canSelectPastDate()}
            isMobile={isMobile}
            id="days-half-method"
          />
        );
      case Constants.MethodType.daysHalfDisabled:
        return (
          <DaysHalfDisabled
            checked={isVacationChecked}
            onChecked={() => onVacationChecked()}
            defaultAM={isToggle}
            onHandleToggle={() => onHandleToggle()}
            dateFrom={dateFrom}
            dateTo={dateTo}
            isMobile={isMobile}
            id="days-half-disabled-method"
          />
        );
      case Constants.MethodType.days:
        return (
          <Days
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            dateFrom={dateFrom}
            onSelectedDateTo={(value) => onSelectedDateTo(value)}
            dateTo={dateTo}
            canSelectPast={canSelectPastDate()}
            id="days-method"
          />
        );
      case Constants.MethodType.hours:
        return (
          <Hours
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            dateFrom={dateFrom}
            dateTo={dateTo}
            isDateToSameAsDateFrom={shouldDateToSameAsDateFrom(type)}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            timeFrom={timeFrom}
            timeTo={timeTo}
            onSelectTimeFrom={handleSetTimeFrom}
            onSelectTimeTo={handleSetTimeTo}
            id="hours-method"
          />
        );
      case Constants.MethodType.hoursSpanned:
        return (
          <HoursSpanned
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            dateFrom={dateFrom}
            onSelectedDateTo={(value) => onSelectedDateTo(value)}
            dateTo={dateTo}
            timeFrom={timeFrom}
            timeTo={timeTo}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            onSelectTimeFrom={handleSetTimeFrom}
            onSelectTimeTo={handleSetTimeTo}
            id="hours-spanned-method"
          />
        );
      case Constants.MethodType.dateHoursInput:
        return (
          <DateHoursInput
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            value={dateFrom}
            timeFrom={timeFrom}
            onSelectTimeFrom={handleSetTimeFrom}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            id="date-hours-input-method"
          />
        );
      case Constants.MethodType.checkInOut:
        return (
          <CheckInOut
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            value={dateFrom}
            timeFrom={timeFrom}
            onSelectTimeFrom={handleSetTimeFrom}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            id="check-in-out-method"
          />
        );
      case Constants.MethodType.hoursAndDaysWhole:
        return (
          <HoursAndDaysWhole
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            dateFrom={dateFrom}
            checked={isVacationChecked}
            onChecked={() => onVacationChecked()}
            timeFrom={timeFrom}
            timeTo={timeTo}
            onSelectTimeFrom={handleSetTimeFrom}
            onSelectTimeTo={handleSetTimeTo}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            dateTo={dateTo}
            id="hours-and-days-whole-method"
          />
        );
      case Constants.MethodType.daysHalfAndHours:
        return (
          <DaysHalfAndHours
            onSelectedDateFrom={(value) => onSelectedDateFrom(value)}
            dateFrom={dateFrom}
            onSelectedDateTo={(value) => onSelectedDateTo(value)}
            dateTo={dateTo}
            checked={isVacationChecked}
            onChecked={() => onVacationChecked()}
            defaultAM={isToggle}
            onHandleToggle={() => onHandleToggle()}
            canSelectPast={canSelectPastDate()}
            isShowHours={isShowHours}
            onShowHoursChecked={() => onShowHours()}
            timeFrom={timeFrom}
            onSelectTimeFrom={handleSetTimeFrom}
            timeTo={timeTo}
            onSelectTimeTo={handleSetTimeTo}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            isMobile={isMobile}
            id="days-half-and-hours-method"
          />
        );
      case Constants.MethodType.daysHalfAndHoursDisabled:
        return (
          <DaysHalfAndHoursDisabled
            checked={isVacationChecked}
            onChecked={() => onVacationChecked()}
            defaultAM={isToggle}
            onHandleToggle={() => onHandleToggle()}
            isShowHours={isShowHours}
            onShowHoursChecked={() => onShowHours()}
            timeFrom={timeFrom}
            onSelectTimeFrom={handleSetTimeFrom}
            is24HoursFormat={isMethodUse24HourFormat(type)}
            dateTo={dateTo}
            dateFrom={dateFrom}
            isMobile={isMobile}
            id="days-half-and-hours-disabled-method"
          />
        );
      case Constants.MethodType.mileage:
        return (
          <Mileage
            onSelected={(value) => onSelectedDateFrom(value)}
            value={dateFrom}
            id="mileage-method"
          />
        );
      default:
        break;
    }
  };

  // Recurrent
  const onRepeatChange = (event) => {
    const {
      target: { value },
    } = event;
    setRepeatWeek(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const onDaysSelected = (name, checked) => {
    setDaysSelected({
      ...daysSelected,
      [name]: checked,
    });
  };

  // add note
  const onAddNote = (event) => {
    setAddNote(event.target.value);
  };

  // on close and save
  const onSave = () => {
    dispatch(getRegistration(rulesParams));
  };

  const onClose = () => {
    window?.ReactNativeWebView?.postMessage("close");
  };

  return (
    <>
      <div className="header" id="main-container">
        <p className="title" id="main-title">
          Add registration
        </p>
        <SvgIcon
          component={CloseIcon}
          color="black"
          className="icon"
          onClick={onClose}
          id="close-button"
        />
      </div>
      <DropdownPicker
        registrationTypes={registrationTypes}
        selectedType={selectedType}
        handleChange={onSelectedTypeChange}
        id="dropdown-picker-main-types"
      />
      {setting.subtype && setting.subtype.length > 0 && (
        <LeaveType
          title={"Type"}
          registration={
            userInfo?.policy?.leaveTypes?.length > 0
              ? userInfo?.policy?.leaveTypes
              : setting.subtype
          }
          onSelected={onSubTypeSelected}
          selectedType={
            subTypeSelected !== "" ? subTypeSelected : setting.subtype[0].name
          }
          id="dropdown-picker-sub-types"
        />
      )}
      {!isEmpty(jobcodes) && (
        <DropdownPicker
          registrationTypes={setting.jobcodes || jobcodes}
          selectedType={jobcode}
          handleChange={onJobcodeChange}
          searchable
          searchText={searchText}
          onSearch={onSearch}
          title={"Select jobcode"}
          id="dropdown-picker-job-codes"
        />
      )}
      {renderItem(setting.method ? setting.method : subtypeMethod)}
      {setting.reccurence && subtypeRecurence && (
        <>
          <RecurringItem
            checked={isRecurrentChecked}
            onChecked={onRecurrentChecked}
            repeatWeek={repeatWeek}
            onRepeatChange={onRepeatChange}
            daysSelected={daysSelected}
            onDaysSelected={(name, checked) => onDaysSelected(name, checked)}
            id="recurring-items"
          />
        </>
      )}
      {setting.note
        ? setting.note && (
            <AddNote
              label={"Add note"}
              note={addNote}
              onNote={onAddNote}
              id="main-add-note"
            />
          )
        : subtypeAddNote && (
            <AddNote
              label={"Add note"}
              note={addNote}
              onNote={onAddNote}
              id="sub-types-add-note"
            />
          )}
      {shouldRenderDialogMessage() && (
        <DialogBox
          color={dialogBoxColor}
          title={dialogMessage}
          icon={dialogIcon}
          id="dialog-message"
        />
      )}
      {shouldRenderSaveBtn() && (
        <div className="button" id="save-container">
          <div
            variant="contained"
            className="button-title"
            onClick={onSave}
            style={{
              backgroundColor: "#35a3dc",
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 15,
              paddingBottom: 15,
              borderRadius: 15,
              color: "#FFF",
            }}
            id="save-button"
          >
            Save
          </div>
          {selectedType === Constants.SettingType.MI && (
            <p color="black" id="mileage-message">
              I used my private car
            </p>
          )}
        </div>
      )}
    </>
  );
}
